export default {
  computed: {
    invoicesRoutes() {
      return {
        "invoices-details": {
          title: "Detalhes"
        },

        "invoices-enotas": {
          title: "eNotas"
        },

        "invoices-bling": {
          title: "Bling"
        },

        "invoices-notazz": {
          title: "Notazz"
        },
      
        "invoices-spedy": {
          title: "Spedy"
        },
      }
    }
  }
}